// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n4-3";
export var downloadButton = "_n4-4";
export var fileContainer = "_n4-9 _n4-7";
export var fileContainerBase = "_n4-7";
export var fileContainerFixedHeight = "_n4-8 _n4-7";
export var fileInfo = "_n4-5";
export var fileInfoWidthRestricted = "_n4-6";
export var fileType = "_n4-1";
export var fileTypeName = "_n4-2";
export var image = "_n4-0";
export var link = "_n4-b";
export var overflowEllipsis = "_n4-a";